
import React from 'react';
import { CostParams } from '../types.ts';

interface CostingPanelProps {
  costParams: CostParams;
  setCostParams: React.Dispatch<React.SetStateAction<CostParams>>;
}

const InputField: React.FC<{label: string, name: string, value: number, onChange: (e: React.ChangeEvent<HTMLInputElement>) => void, type?: string, step?: string, unit: string}> = 
({label, name, value, onChange, type="number", step="0.01", unit}) => (
    <div>
      <label htmlFor={`cost-${name}`} className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="mt-1 relative rounded-md shadow-sm">
        <input type={type} name={name} id={`cost-${name}`} value={value} onChange={onChange} step={step} className="block w-full p-2 border border-gray-300 rounded-md pr-12 bg-white text-gray-900"/>
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">{unit}</span>
        </div>
      </div>
    </div>
);

const CostingPanel: React.FC<CostingPanelProps> = ({ costParams, setCostParams }) => {
  const handleParamChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    if (type === 'checkbox') {
        const { checked } = e.target as HTMLInputElement;
        setCostParams(prev => ({ ...prev, [name]: checked }));
    } else {
        setCostParams(prev => ({ ...prev, [name]: parseFloat(value) || 0 }));
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-lg">
      <h3 className="text-xl font-bold mb-4 text-gray-800 border-b pb-2">Parametri di Costo</h3>
      <div className="space-y-4">
        
        <div className="p-3 bg-gray-50 rounded-lg">
            <h4 className="font-semibold text-gray-600 mb-2">Materia Prima & Filatura</h4>
            <div className="grid grid-cols-2 gap-4">
                <InputField label="Costo Cotone" name="cottonCostPerKg" value={costParams.cottonCostPerKg} onChange={handleParamChange} unit="€/Kg" />
                <InputField label="Costo Filatura" name="spinningCostPerKg" value={costParams.spinningCostPerKg} onChange={handleParamChange} unit="€/Kg" />
                <InputField label="Costo Elastomero" name="elastomerCostPerKg" value={costParams.elastomerCostPerKg} onChange={handleParamChange} unit="€/Kg" />
            </div>
        </div>

        <div className="p-3 bg-gray-50 rounded-lg">
            <h4 className="font-semibold text-gray-600 mb-2">Lavorazione & Calo</h4>
            <div className="grid grid-cols-2 gap-4">
              <InputField label="Costo Tessitura" name="weavingCostPerMeter" value={costParams.weavingCostPerMeter} onChange={handleParamChange} unit="€/m" />
              <InputField label="% Calo Tessitura" name="weavingWaste" value={costParams.weavingWaste} onChange={handleParamChange} unit="%" step="1" />
              <InputField label="% Calo Finissaggio" name="finishingWaste" value={costParams.finishingWaste} onChange={handleParamChange} unit="%" step="1" />
            </div>
        </div>

        <div className="p-3 bg-gray-50 rounded-lg">
            <h4 className="font-semibold text-gray-600 mb-2">Spese</h4>
             <div className="flex items-center">
                <input id="includeGeneralExpenses" name="includeGeneralExpenses" type="checkbox" checked={costParams.includeGeneralExpenses} onChange={handleParamChange} className="h-4 w-4 text-sky-600 border-gray-300 rounded focus:ring-sky-500"/>
                <label htmlFor="includeGeneralExpenses" className="ml-2 block text-sm text-gray-900">Includi Spese Generali ({costParams.generalExpensesPercentage}%)</label>
             </div>
        </div>
      </div>
    </div>
  );
};

export default CostingPanel;
